import { render, staticRenderFns } from "./CustomerManagementNavigator.vue?vue&type=template&id=75bdfe9a"
import script from "./CustomerManagementNavigator.vue?vue&type=script&lang=js"
export * from "./CustomerManagementNavigator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports